module.exports = __webpack_public_path__ + "nick-barraclough-ae74164526532cc8798f0a4bd3394160.webp";